<div class="flex flex-col gap-3 border rounded-md p-4">
  <div class="flex items-center gap-2">
    <i
      class="icon-wl-arrow-drop-down text-6 cursor-pointer transition"
      [ngClass]="isExpanded ? '' : '-rotate-90'"
      (click)="onToggleExpanded()"></i>
    <span class="text-4 font-semibold">
      {{ report.name === 'ALL' ? report.name : index + '. ' + report.name }}
    </span>
    <div
      class="h-6 min-w-6 px-1 w-fit flex items-center justify-center text-neutral-800 bg-neutral-300 rounded-sm font-medium">
      {{ report.data?.total }}
    </div>
  </div>

  @if (isExpanded) {
    <p-table
      [value]="data"
      [scrollable]="true"
      [customSort]="true"
      [lazy]="true"
      (onSort)="onSort($event)"
      [loading]="isLoading">
      <ng-template pTemplate="header">
        <tr class="truncate">
          @for (col of visibleColumns; track $index) {
            <th class="!text-right" [pSortableColumn]="NOTE_EXPORT_TO_SORT_FIELD[col.key]!">
              <app-sort-table-header
                [label]="translatePrefix + col.labelKey | translate"
                [sortField]="sortField"
                [sortOrder]="sortOrder"
                [field]="NOTE_EXPORT_TO_SORT_FIELD[col.key]!"></app-sort-table-header>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="truncate">
          @for (col of visibleColumns; track $index) {
            @switch (col.key) {
              @case (NoteExportFieldEnum.LEAD_ID) {
                <td class="!text-left">
                  <div class="flex items-center">
                    <div>{{ item?.leadInfoRepresentation?.leadId }}</div>
                  </div>
                </td>
              }
              @case (NoteExportFieldEnum.LEAD_NAME) {
                <td class="!text-left">
                  <a
                    [routerLink]="['/lead-management', 'lead-details', item?.leadInfoRepresentation?.id, 'overview']"
                    class="text-blue-600 hover:underline">
                    {{ item?.leadInfoRepresentation?.fullName }}
                  </a>
                </td>
              }
              @case (NoteExportFieldEnum.POLICY_NO) {
                <td class="!text-left">{{ item?.policy?.number || '--' }}</td>
              }
              @case (NoteExportFieldEnum.OWNER) {
                <td class="!text-left">
                  <a
                    [routerLink]="['/lead-management', 'lead-details', item?.leadInfoRepresentation?.id, 'overview']"
                    class="text-blue-600 hover:underline">
                    {{ item?.leadInfoRepresentation?.owner?.fullName }}
                  </a>
                </td>
              }
              @case (NoteExportFieldEnum.AGENT) {
                <td class="!text-left">{{ item?.leadInfoRepresentation?.agent?.fullName || '--' }}</td>
              }
              @case (NoteExportFieldEnum.CELL_PHONE) {
                <td class="!text-left">{{ (item?.leadInfoRepresentation?.cellPhone | phoneNumber) || '--' }}</td>
              }
              @case (NoteExportFieldEnum.EMAIL) {
                <td class="!text-left">{{ item?.leadInfoRepresentation?.email || '--' }}</td>
              }
              @case (NoteExportFieldEnum.ADDED_BY) {
                <td class="!text-left">{{ item?.createdBy?.fullName || '--' }}</td>
              }
              @case (NoteExportFieldEnum.ADDED_DATE) {
                <td class="!text-left">{{ item?.createdAt | date: 'MM/dd/yyyy hh:mm' }}</td>
              }
              @case (NoteExportFieldEnum.LAST_NOTE) {
                <td class="!text-left">{{ (getLastReplyNote(item) | date: 'MM/dd/yyyy hh:mm') || '--' }}</td>
              }
              @case (NoteExportFieldEnum.TYPE_NOTE) {
                <td class="!text-left overflow-visible" style="min-width: 200px">
                  <div
                    class="max-w-50 truncate"
                    [pTooltip]="item?.status?.name ? item?.status?.name : null"
                    tooltipPosition="top">
                    <span>{{ item?.status?.name || '--' }}</span>
                  </div>
                </td>
              }
              @case (NoteExportFieldEnum.NOTE) {
                <td class="!text-left whitespace-normal" style="min-width: 400px; max-width: 600px">
                  <div class="max-w-[600px]">
                    <span
                      class="break-words"
                      [innerHTML]="
                        item?.notes +
                          ' Added by ' +
                          (item?.createdBy?.fullName || '--') +
                          ' ' +
                          (item?.createdAt | date: 'MM/dd/yyyy hh:mm:ss') | safeHtml
                      "></span>
                  </div>
                  @if (item?.replyNotes?.length > 0) {
                    <span class="block mt-3">Append:</span>
                    <div class="flex gap-1 flex-col">
                      @for (reply of item.replyNotes; track reply.id) {
                        <div class="max-w-[600px]">
                          <span
                            class="break-words"
                            [innerHTML]="
                              reply?.notes +
                                ' Added by ' +
                                (reply?.createdBy?.fullName || '--') +
                                ' ' +
                                (reply?.createdAt | date: 'MM/dd/yyyy hh:mm:ss') | safeHtml
                            "></span>
                        </div>
                      }
                    </div>
                  }
                </td>
              }
            }
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="20">
            <app-empty-table></app-empty-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    @if (report.data.total > 5) {
      <app-custom-paginator
        [(pagination)]="pagination"
        [totalRecords]="report.data.total"
        [options]="options"
        (onChange)="onPagination()"></app-custom-paginator>
    }
  }
</div>
